import { render, staticRenderFns } from "./RenameUserDialog.vue?vue&type=template&id=0ae76aa0&scoped=true"
import script from "./RenameUserDialog.vue?vue&type=script&lang=js"
export * from "./RenameUserDialog.vue?vue&type=script&lang=js"
import style0 from "./RenameUserDialog.vue?vue&type=style&index=0&id=0ae76aa0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae76aa0",
  null
  
)

export default component.exports